import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { omit } from "lodash";
import { useParams } from "react-router-dom";

let myModal = {};

export default function ModelCustomPrice(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [selected_value, SetSelectedValue] = useState("Service");
  const [service_data, SetServiceData] = useState({});
  const [selected, SetSelected] = useState("");

  useEffect(() => {
    console.log("ModelCustomPrice On mount :", props);
    let myModal1 = document.getElementById("ViewCustomPrice");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      SetServiceData({});
      console.log("close_data :", close_data);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModelCustomPrice On mount :", props);
      let service_value = props.data;
      Object.keys(service_value).forEach((key, index) => {
        if (index == 0) {
          SetSelected(key);
        }
        service_value[key].map((ele, ele_index) => {
          if (ele.total_price > 0) {
            ele.checked = true;
          } else {
            ele.checked = false;
          }
        });
      });

      SetServiceData(service_value);

      myModal = new bootstrap.Modal(
        document.getElementById("ViewCustomPrice"),
        {}
      );
      myModal.show();
    }
  }, [props.open]);

  async function update_custom_price() {
    console.log("update_custom_price ");
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        company_id: id_value.company_id,
      },
      post: {
        services: service_data,
      },
    };
    let data = await api("/outlet/update_company_service_price", pass_data);
    console.log("update_company_service_price response :", data.response);
    if (data.response.hasOwnProperty("service_price")) {
      let item = close_data;
      item.action = "save";
      item.value = data.response.service_price;
      SetCloseData(item);
      myModal.hide();
    }
  }

  return (
    <div
      className="modal fade"
      id="ViewCustomPrice"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title" id="ModalLabel">
              <h5>Add / Edit Custom Prices</h5>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                SetServiceData({});
                SetSelected();
                myModal.hide();
              }}
            ></button>
          </div>

          <div className="modal-body">
            <form className="g-3">
              <div className="row">
                {Object.keys(service_data).map((ele, index) => (
                  <div
                    className="col-md-4 col-6 pb-2"
                    key={index}
                    onClick={() => {
                      SetSelected(ele);
                      console.log("service_data :", service_data[selected]);
                    }}
                  >
                    <div
                      className={
                        selected == ele
                          ? "withActive cursor"
                          : "withoutActive cursor"
                      }
                    >
                      <div className="row text-center align-items-center">
                        <div className="col-3">
                          {ele == "type_1" ? (
                            <img
                              src={require("../../../assets/icon/svg/image1.svg")}
                            />
                          ) : ele == "type_2" ? (
                            <img
                              src={require("../../../assets/icon/svg/video1.svg")}
                            />
                          ) : (
                            <img
                              src={require("../../../assets/icon/svg/music1.svg")}
                            />
                          )}
                        </div>

                        <div className="col-9">
                          <p className="d-sm-none d-md-block mb-0">
                            {ele == "type_1"
                              ? "Images"
                              : ele == "type_2"
                                ? "Videos"
                                : "Audios"}
                          </p>
                          <p className="v-small d-sm-block d-md-none mb-0">
                            {ele == "type_1"
                              ? "Images"
                              : ele == "type_2"
                                ? "Videos"
                                : "Audios"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="pt-2">

                {selected != "" ? (
                  <div className="mt-3"
                  // id={"accordion" + selected}
                  >
                    {Object.keys(service_data).length > 0
                      ? service_data[selected].map((ele, ele_index) =>
                        ele.total_price >= 0 ? (
                          <div key={ele_index}>
                            <div
                              // className="accordion-header"
                              id={"heading" + selected + ele_index}
                            >
                              <div className="row">

                                <div className="col-sm-6 col-12 mb-2">
                                  <h6 className="ms-1">{ele.name}</h6>
                                </div>

                                <div className="col-sm-3 col-6 mb-2 text-center">
                                  <div className="radio">
                                    <label>
                                      <input
                                        type="radio"
                                        value="Service"
                                        className="me-2"
                                        checked={selected_value === "Service"}
                                        onChange={() => {
                                          SetSelectedValue("Service");

                                        }}
                                      // disabled={read_only}
                                      />
                                      Service
                                    </label>
                                  </div>

                                </div>
                                <div className="col-sm-3 col-6 mb-2 text-center">
                                  <div className="radio">
                                    <label>
                                      <input
                                        type="radio"
                                        className="me-2"
                                        value="Task"
                                        checked={selected_value === "Task"}
                                        onChange={() => {
                                          SetSelectedValue("Task");

                                        }}
                                      // disabled={read_only}
                                      />
                                      Task
                                    </label>
                                  </div>
                                </div>
                              </div>

                              {selected_value == "Service" ? (
                                <div className="px-3 mt-2">
                                  <small className="fs-6 text-gray"><b>Service</b></small>
                                  <div className="d-flex align-items-center px-0 pt-2">
                                    <label className="form-label mb-0">Price</label>
                                    <input
                                      type="number"
                                      className="form-control w-30 ms-2 p-1"
                                      value={ele.price}
                                      onChange={(e) => {
                                        SetServiceData((prevValue) => {
                                          prevValue[selected][
                                            ele_index
                                          ].price = e.target.value;
                                          return { ...prevValue };
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              ) : (
                                <div>
                                  {ele.task.length === 0 ? (
                                    <p>No Service Tasks </p>
                                  ) : (
                                    <div className="px-3 mt-2">
                                      <small className="fs-6 text-gray"><b>Tasks</b></small>
                                      {ele.task.map(
                                        (task_ele, task_index) => (
                                          <div
                                            className="pt-1 row align-items-center"
                                            key={task_index}
                                          >
                                            <div className="col-7">
                                              <p className="mb-0 text-dark fs-6 fw-bolder">
                                                {task_ele.name}
                                              </p>
                                            </div>

                                            <div className="col-5 text-end">
                                              <div className="d-flex align-items-center">
                                                <p className="text-gray mb-0">Price</p>
                                                <input
                                                  type="number"
                                                  value={task_ele.price}
                                                  className="form-control ms-2 p-1"
                                                  onChange={(e) => {
                                                    SetServiceData(
                                                      (prevValue) => {
                                                        prevValue[selected][
                                                          ele_index
                                                        ].task[
                                                          task_index
                                                        ].price =
                                                          e.target.value;
                                                        return {
                                                          ...prevValue,
                                                        };
                                                      }
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        ) : null
                      )
                      : null}
                  </div>
                ) : null}



                {/* {selected != "" ? (
                    <div className="accordion mt-3" id={"accordion" + selected}>
                      {Object.keys(service_data).length > 0
                        ? service_data[selected].map((ele, ele_index) =>
                          ele.total_price >= 0 ? (
                            <div className="accordion-item" key={ele_index}>
                              <div
                                className="accordion-header"
                                id={"heading" + selected + ele_index}
                              >
                                <div className="accordion-button ">
                                  <div className="row">
                                    <label className="d-flex">
                                      <input
                                        type="checkbox"
                                        name="service"
                                        checked={ele.checked}
                                        onChange={(e) => {
                                          SetServiceData((prevValue) => {
                                            if (ele.checked) {
                                              prevValue[selected][
                                                ele_index
                                              ].checked = false;
                                              prevValue[selected][
                                                ele_index
                                              ].price = "";
                                              prevValue[selected][
                                                ele_index
                                              ].task.map((t_ele, e_index) => {
                                                t_ele.price = "";
                                              });
                                            } else {
                                              prevValue[selected][
                                                ele_index
                                              ].checked = true;
                                            }
                                            return { ...prevValue };
                                          });
                                        }}
                                      />
                                      <h6 className="ms-1">{ele.name}</h6>
                                    </label>
                                    <div className="col-6 d-flex align-items-center ps-0 pt-2">
                                      <p className=" mb-0">Defalut price</p>{" "}
                                      <span className="fw-bold text-dark ms-1">
                                        ₹{ele.default_price}
                                      </span>
                                    </div>
                                    <div className="col-6 d-flex align-items-center px-0 pt-2">
                                      <p className="mb-0">Custom Price</p>
                                      {ele.checked == true ? (
                                        <input
                                          type="number"
                                          className="form-control w-30 ms-2 p-1"
                                          value={ele.price}
                                          onChange={(e) => {
                                            SetServiceData((prevValue) => {
                                              prevValue[selected][
                                                ele_index
                                              ].price = e.target.value;
                                              return { ...prevValue };
                                            });
                                          }}
                                        />
                                      ) : (
                                        <span className="fw-bold text-dark ms-1">
                                          ₹{ele.price}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <div
                                    className=" ms-auto cursor"
                                    data-bs-toggle="collapse"
                                    data-bs-target={
                                      "#collapse" + selected + ele_index
                                    }
                                    aria-expanded="true"
                                    aria-controls={
                                      "collapse" + selected + ele_index
                                    }
                                  >
                                    <i className="fas fa-chevron-down"></i>
                                  </div>
                                </div>
                                <div
                                  id={"collapse" + selected + ele_index}
                                  className="accordion-collapse collapse "
                                  aria-labelledby={
                                    "heading" + selected + ele_index
                                  }
                                  data-bs-parent={"#accordion" + selected}
                                >
                                  <div className="accordion-body row">
                                    {ele.task.length === 0 ? (
                                      <p>No Service Tasks </p>
                                    ) : (
                                      <>
                                        <p>Service Tasks</p>

                                        {ele.task.map(
                                          (task_ele, task_index) => (
                                            <div
                                              className="pt-2 col-6"
                                              key={task_index}
                                            >
                                              <h6 className="ms-1">
                                                {task_ele.name}
                                              </h6>
                                              <div className="mt-2 d-flex align-items-center">
                                                <p className="text-gray mb-0">
                                                  Defalut Price
                                                </p>
                                                <span className="fw-bold text-dark ms-1">
                                                  ₹{task_ele.default_price}
                                                </span>
                                              </div>
                                              <div className="mt-2 d-flex align-items-center">
                                                <p className="text-gray mb-0">
                                                  Custom Price
                                                </p>
                                                {ele.checked == true ? (
                                                  <input
                                                    type="number"
                                                    value={task_ele.price}
                                                    className="form-control w-25 ms-2 p-1"
                                                    onChange={(e) => {
                                                      SetServiceData(
                                                        (prevValue) => {
                                                          prevValue[selected][
                                                            ele_index
                                                          ].task[
                                                            task_index
                                                          ].price =
                                                            e.target.value;
                                                          return {
                                                            ...prevValue,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  />
                                                ) : (
                                                  <span className="fw-bold text-dark ms-1">
                                                    ₹{task_ele.price}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                          )
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null
                        )
                        : null}
                    </div>
                  ) : null} */}
              </div>
            </form>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              // data-bs-dismiss="modal"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                update_custom_price();
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
